import { ApplicationState } from '../store';
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { CaretRightOutlined } from '@ant-design/icons/lib';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Table, Collapse, Button, Select, message, Form, Row, Col, Tabs, List, Modal, Switch, Spin, Radio } from 'antd';
const { Option } = Select;
const { Item } = Form;
import * as React from "react";
import * as AuthStore from "../store/Auth";
//import img from '../images/user-icon-1.png';
import { fetchData, postQuery } from '../utils';
import "../styles/chat.css";
const { Panel } = Collapse;

type AuthProps =
    AuthStore.AuthState // ... state we've requested from the Redux store
    & typeof AuthStore.actionCreators // ... plus action creators we've requested

class ArtSchedule extends React.Component<AuthProps>
{
    public state =
        {
            buttonText: 'Add',
            states: [],
            sites: [],
            statesLoaded: false,
            facilities: [],
            schedulingFacilities: [],
            data: [],
            loading: false,
            loadingOth: false,
            confirmLoading: false,
            site: { Id: '', name: '', stateCode: '', lga: '', siteId: '', state: '' },
            state: { id: 0, name: '', code: '', sites: [], stateId: 0 },
            searchObj:
            {
                state: '',
                site: 0,
                siteName: '',
                stateName: ''
            },
            pagination:
            {
                current: 1,
                total: 0,
                pageSize: 10,
                sorter:
                {
                    field: "name",
                    order: "asc"
                }
            },
            searchText: "",
            visible: false,
            schedule: { id: 0, scheduledDateStr: '', dateInitiatedStr: '', message: '', status: 1, messageToClient: '' },
            client:
            {
                datim: '',
                patientId: 0,
                pepfarId: '',
                facilityId: 0,
                schedules: [],
                pendingArtRequest: 0,
                nextAppointmentDate: '',
                lastDaysOfRefill: 0,
                lastDrugPickup: '',
                currentRegimenLine: '',
                currentRegimen: '',
                artStartDate: '',
                sex: '',
                hospitalNumber: ''
            },
            loadingMsg: false,
            hasMore: false,
        };

    ////@ts-ignore
    async componentDidMount() {
        let el = this;
        let user = this.props.appUser;

        let sts = localStorage.getItem("states");
        let states = [];
        if (sts) states = JSON.parse(sts);

        if (user.stateCode && user.stateCode.length > 0)
        {
            var statex = states.filter(s =>
            {
                return s.stateCode.toLocaleLowerCase() === user.stateCode.toLocaleLowerCase();
            });
            if (statex.length > 0)
            {
                let { searchObj } = this.state;
                let state: any = states[0];
                this.setState({ state, searchObj });
            }
        }

        let statesLoaded = true;
        this.setState({ states, statesLoaded });
        el.getRefills();
    }

    async getRefills()
    {
        //alert();
        let el = this;
        if (el.state.searchObj.site)
        {
            var ffc = el.state.facilities.filter(f => f.facilityId === el.state.searchObj.site);
            if (ffc.length > 0)
            {
                el.setState({ schedulingFacilities: ffc });
            }
            else
            {
                el.setState({ schedulingFacilities: [] });
            }
        }
        else
        {
            var ffc = el.state.facilities.filter(f => f.stateId === el.state.state.stateId);
            if (ffc.length > 0)
            {
                el.setState({ schedulingFacilities: ffc });
            }
            else
            {
                var query = `/api/Jolly95/getArtSchedulingSities?stateId=${el.state.state.stateId}`;
                this.setState({ loading: true });
                let res = await fetchData(query);
                this.setState({ facilities: res, schedulingFacilities: res, loading: false });
            }
        }
    }

    selectSite(value: any) {
        const { searchObj } = this.state;
        if (value) {
            searchObj.site = value.key;
            let sites: any = this.state.sites.filter(function (o: any) { return o.siteId === searchObj.site });
            if (sites.length > 0) searchObj.siteName = sites[0].name;
            this.setState({ searchObj, sites });
        }
    }

    selectState(value: any)
    {
        var el = this;
        if (!value)
        {
            return;
        }
        const { searchObj } = this.state;
        searchObj.site = 0;
        if (value)
        {
            let val = value.key;
            let states = this.state.states.filter(function (s: any) { return s.stateId === val });
            if (states.length > 0) {
                var state = states[0];
                el.setState({ state: state, searchObj: searchObj });
            }
        }
    }
    
    //edit(data: any, row: any) {
    //    this.setState({ visible: true, title: 'Update Site', buttonText: 'Update', schedule: data });
    //}

    exit() {
        this.setState({ visible: false });
    }

    async getPatientSchedules(p)
    {
        let el = this;
        el.setState({ client: p, loadingMsg: true });
        let res = await fetchData(`/api/Jolly95/getPatientArtSchedules?patientId=${p.patientId}`);
        el.setState({ loadingMsg: false });
        if (res.length > 0)
        {           
            var { client } = el.state;
            client.schedules = res;
            this.setState({ client });
        }
    }

    textChange(feture: any, e: any)
    {
        let { schedule } = this.state;
        schedule[feture] = e.target.value;
        this.setState({ schedule });
    }

    async updateSchedule()
    {
        let el = this;
        const { schedule } = el.state;
        if (schedule.messageToClient.length < 1)
        {
            message.error("Please provide a feedback to the Client");
            return;
        }
        if (schedule.status < 2)
        {
            message.error("Please Approve or Reject this Request");
            return;
        }       
        var sc = { id: schedule.id, pepfarId: el.state.client.pepfarId, datimCode: el.state.client.datim, messageToClient: schedule.messageToClient.replace(/\'/g, "''"), status: schedule.status };
        el.setState({ loading: true });
        let res = await postQuery(`/api/Jolly95/updateArtSchedule`, JSON.stringify(sc));
        el.setState({ loading: false });

        if (res.code > 0)
        {
            message.success(res.message);
            this.setState({ visible: false, });
        }
        else
        {
            message.error(res.message);
        }
    }

    async editSchedule(d)
    {
        let el = this;
        el.setState({ schedule: d, visible: true });
    }

    selectStatus(e) {
        let { schedule } = this.state;
        schedule.status = e.target.value;
        this.setState({ schedule });
    };

    render() {
        let el = this;
        const { facilities, client, loading, state, states, visible, schedule, schedulingFacilities, loadingMsg, hasMore } = this.state;
        let user = this.props.appUser;
        return (
            <div style={{ marginTop: '15px', padding: '20px' }}>
                <Helmet>
                    <title>CDR :: ART Schedule</title>
                </Helmet>
                <div className="custom-filter-dropdown" style={{ borderWidth: '2', borderColor: '#000000' }}>
                    <Row>
                        <div id="container" style={{ borderWidth: '2', borderColor: '#000000', width: '100%'}}>
                            <Row style={{ marginTop: '2px' }}>
                                <Col span={24} style={{ padding: '10px' }}>
                                    <h4 style={{ fontWeight: 'bold', fontSize: '18px' }}>ART Refill Schedule</h4>
                                </Col>
                            </Row>
                            <br />
                            <aside style={{ overflowY: 'auto', width: '30%' }}>
                                <header>
                                    <Row>                                        
                                        {!user.stateCode &&
                                            <Col span={24}>
                                                <Select
                                                    labelInValue className="top-10-margin"
                                                    showSearch
                                                    optionFilterProp="children"
                                                    disabled={loading}
                                                    style={{ width: '98%' }}
                                                    placeholder="Select State"
                                                    onChange={(value) => this.selectState(value)}
                                                >
                                                    <Option key="" value="">-- Select State --</Option>
                                                    {states && states.map((s: any) => <Option key={s.stateId} value={s.stateId}>{s.stateName}</Option>)}
                                                </Select>
                                            </Col>
                                        }
                                        <Col span={24}>
                                            <Select
                                                labelInValue className="top-10-margin"
                                                showSearch
                                                optionFilterProp="children"
                                                disabled={loading}
                                                style={{ width: '98%' }}
                                                placeholder="Select Facility"
                                                onChange={(value) => this.selectSite(value)}
                                            >
                                                <Option key="" value="">-- Select Facility --</Option>
                                                {state.sites && state.sites.map((s: any) => <Option key={s.id} value={s.id}>{s.name}</Option>)}
                                            </Select>
                                        </Col>
                                        <Col span={24}>
                                            <Button disabled={loading} className="login-button top-10-margin" id="push-btn" loading={loading} key="submit" type="primary" size="large" onClick={() => this.getRefills()} style={{ paddingRight: '40px', paddingLeft: '40px', float: 'right', width: '100%' }}>
                                                <span id="buttonText">Filter</span>
                                            </Button>
                                        </Col>
                                    </Row>
                                </header>                                
                                <Collapse bordered={false} expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />} className="site-collapse-custom-collapse" >
                                    {schedulingFacilities && schedulingFacilities.map(j => <Panel header={j.facilityName} key={j.datim} className="site-collapse-custom-panel">
                                        <Row style={{ marginBottom: '8px' }}>
                                            <Col span={24}>
                                                <ul className='mcd'>
                                                    {j.clients && j.clients.map(m => <li key={m.pepfarId} style={{ cursor: 'pointer' }} onClick={() => el.getPatientSchedules(m)}>
                                                        <img src="../images/user-icon-1.png" alt="" />
                                                        <div>
                                                            <h2>{m.pepfarId}</h2>
                                                            <h3>
                                                                {m.PendingArtRequest > 0 ? <p> Pending Review :  <span style={{ fontSize: '11px', fontWeight: 'bold', color: '#ff725d' }}>&nbsp;     ({m.PendingArtRequest})</span></p> : ''}
                                                            </h3>
                                                        </div>
                                                    </li>)}
                                                </ul>
                                            </Col>
                                        </Row>
                                    </Panel>)}
                                </Collapse>
                            </aside>
                            {client.pepfarId.length > 0 && <div className="main" style={{ width: '70%' }}>
                                <div className="ant-col-24">
                                    <div className='ant-row' style={{ borderBottom: '1px solid #e0e0e0', paddingLeft: '10px'}}>
                                        <div className='ant-col-24 padding-md'>
                                            Unique Id: <h6>{client.pepfarId}</h6>
                                        </div>
                                    </div>
                                    <div className='ant-row' style={{ borderBottom: '1px solid #e0e0e0', paddingLeft: '10px' }}>
                                        <div className='ant-col-24 padding-md'>
                                            Current Regimen: <h6>{client.currentRegimen} : {client.currentRegimenLine}</h6>
                                        </div>
                                    </div>
                                    <div className='ant-row' style={{ borderBottom: '1px solid #e0e0e0', paddingLeft: '10px' }}>
                                        <div className='ant-col-8 padding-md'>
                                            Pickup Date: <h6>{client.lastDrugPickup}</h6>
                                        </div>
                                        <div className='ant-col-8 padding-md'>
                                            Next Appointment: <h6>{client.nextAppointmentDate}</h6>
                                        </div>
                                        <div className='ant-col-8 padding-md'>
                                            Duration: <h6>{client.lastDaysOfRefill}</h6>
                                        </div>
                                    </div> 
                                </div>
                                <Row>
                                    <Col span={24}>
                                        <List style={{ backgroundColor: '#fff' }} dataSource={client.schedules}
                                            renderItem={m => (
                                                <List.Item key={m.id} style={{ borderBottom: '1px solid #e0e0e0' }}>
                                                    <Form>
                                                        <div className='ant-row'>
                                                            <div className='ant-col-8 padding-md'>
                                                                Date Initiated: <h6>{m.dateInitiatedStr}</h6>
                                                            </div>
                                                            <div className='ant-col-8 padding-md'>
                                                                Date Requested: <h6>{m.scheduledDateStr}</h6>
                                                            </div>
                                                            <div className='ant-col-8 padding-md'>
                                                                Status: <h6>{m.status === 1 ? 'Pending' : m.status === 2 ? 'Approved' : 'Rejected'}</h6>
                                                            </div>
                                                        </div>
                                                        <div className='ant-row'>
                                                            <div className='ant-col-24 padding-md'>
                                                                <label>Message</label>
                                                                <p style={{ maxHeight: '80px' }}>{m.message}</p>
                                                            </div>
                                                        </div>
                                                        <Row>
                                                            <Col span={4}>
                                                                <Button type="default" className="btnd2" onClick={() => el.editSchedule(m)}>
                                                                    Update Schedule
                                                                 </Button>
                                                            </Col>
                                                        </Row>
                                                    </Form>
                                                </List.Item>
                                            )}
                                        >
                                        </List>
                                        <footer><div className="ant-row" style={{ rowGap: '0px' }}><div className="ant-col ant-col-20"></div><div className="ant-col ant-col-4"></div></div></footer>
                                    </Col>
                                </Row>
                            </div>}
                            <div className="md-wrapper">
                                <Modal className="modal-width-500"
                                    visible={visible}
                                    title='Drug Pickup Reschedule'
                                    maskClosable={false}
                                    onOk={() => el.updateSchedule()}
                                    onCancel={() => this.exit()}
                                    okText="Submit"
                                    cancelText="Cancel">
                                    <Form>
                                        <div className='ant-row'>
                                            <div className='ant-col-8 padding-md'>
                                                <Radio.Group onChange={(e) => el.selectStatus(e)} value={schedule.status}>
                                                    <Radio value={2}>Approve</Radio>
                                                    <Radio value={3}>Reject</Radio>
                                                </Radio.Group>
                                            </div>
                                        </div>
                                        <div className='ant-row'>
                                            <div className='ant-col-24 padding-md'>
                                                <textarea style={{ width: '100%', height: '140px' }} id='txt-msg' placeholder="Feedback to Client *" onChange={(e) => this.textChange('messageToClient', e)} value={schedule.messageToClient} ></textarea>
                                            </div>
                                        </div>
                                    </Form>
                                </Modal>
                            </div>
                        </div>
                    </Row>
                    <br />
                    <br />
                </div>
            </div>
        )
    }
}

export default connect(
    (state: ApplicationState) => state.auth, // Selects which state properties are merged into the component's props
    AuthStore.actionCreators // Selects which action creators are merged into the component's props
)(ArtSchedule as any);
